export default __webpack_public_path__ + "static/media/img_step_2.33a7cb7d.svg";